import * as Sentry from "@sentry/react";

const isDev = import.meta.env.MODE === "development";

Sentry.init({
  dsn: "https://53c4738823e1348d6a6ace7d0b806f03@o4510101052325888.ingest.us.sentry.io/4510101054029824",
  enableLogs: true,
  environment: import.meta.env.MODE || "development",
  // debug: import.meta.env.MODE === "development", // Enable debug mode in development
  // enabled: !isDev, // Explicitly enable Sentry even in development
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  integrations: [
    //  performance
    // If you're using react router, use the integration for your react router version instead.
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.browserTracingIntegration(),
    //  performance
    //  session-replay
    Sentry.replayIntegration(),
    //  session-replay
    // Console logging integration for capturing console.error
    Sentry.consoleLoggingIntegration({ levels: ["error"] }),
  ],
  beforeSend(event, hint) {
    if (hint?.originalException) {
      console.error(hint.originalException);
    } else {
      console.error("Captured Sentry event:", event);
    }

    return event;
  },
});